// popup.js
let popupShown = false;

function showPopup() {
  if (!popupShown) {
    const popup = document.getElementById("exit-popup");
    popup.classList.remove("hidden");

    // let animation start
    setTimeout(() => {
      document.querySelector(".popup-box").classList.add("show");
    }, 50);

    popupShown = true;
  }
}

function hidePopup() {
  const popup = document.getElementById("exit-popup");

  document.querySelector(".popup-box").classList.remove("show");

  setTimeout(() => {
    popup.classList.add("hidden");
  }, 300);
}

// Exit intent
document.addEventListener("mouseleave", function(e) {
  if (e.clientY < 0 && !popupShown) {
    showPopup();
  }
});

// Close popup
document.addEventListener("click", function(e) {
  if (
    e.target.classList.contains("popup-close") ||
    e.target.classList.contains("popup-overlay")
  ) {
    hidePopup();
  }
});
